import { render, staticRenderFns } from "./Categoryselect.vue?vue&type=template&id=29492815&"
import script from "./Categoryselect.vue?vue&type=script&lang=js&"
export * from "./Categoryselect.vue?vue&type=script&lang=js&"
import style0 from "./Categoryselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports